<iboxtools *ngIf="verDetalle" [Title]="" 
            isHistory='true' 
            [enableBack]="true" 
            [DateInit]="infoIdentidad?.desde" 
            [DateEnd]="infoIdentidad?.hasta"
            [IsEditing]="isEditing" 
            (BackChange)="OnBackChange()" 
            [PeriodList]="infoIdentidadHistoryList" 
            (DeleteChange)="OnDeleteChange($event)" 
            (NewChange)="OnNewChange($event)"
            (EditChange)="OnEditChange($event)" 
            (PeriodChange)="OnPeriodChange($event)" 
            (CancelChange)="OnCancelChange($event)" 
            (SaveChange)="OnSaveChange($event)" 
            (CutChange)="OnCutChange()"
            [Permiso]="permisoEdicion"
            [CurrentPeriod]="infoIdentidad?.id">
</iboxtools>

<app-info-identidad-list *ngIf="!verDetalle && !buscando" [personalId]="personalId" 
                                                         [infoIdentidades]="infoIdentidades" 
                                                         [permisoEdicion]="permisoEdicion"
                                                         [fechaslist]="fechaslist"
                                                         (VisualizarDetalle)="OnVisualizarDetalle($event)">
</app-info-identidad-list>

<app-info-identidad-detalle #ChildInfoIdentidadDetalle [infoIdentidad]="infoIdentidad" *ngIf="verDetalle" 
                          [enabledForm]="habilitarFormDetalle" 
                          [MensajeError]="MensajeError" 
                          [desdeAnterior]="desdeAnterior" 
                          [ingreso]="ingreso"
                          [anteriorRetroactividad]="anteriorRetroactividad" 
                          [grupoLiq]="gruposLiquidaciones" 
                          [identidadesInvalida]="identidadesInvalida">
</app-info-identidad-detalle>

